import Page from "app/components/Page";

export default function Balances() {
  return <Page fullWidth title="Balances" />;
}
